import { Button } from 'components/Button'
import Styles from './RemoveGuestModal.module.scss'
import { RemoveGuestWithoutBranchesProps } from './Types'

const RemoveGuestWithoutBranches = ({ onRemove, guestName }: RemoveGuestWithoutBranchesProps) => (
  <>
    <div className={Styles.body}>
      Are you sure you want to remove the guest <b>{guestName}</b> from this workspace?
    </div>
    <div className={Styles.actions}>
      <Button size="xl" onPress={onRemove}>
        Remove from Workspace
      </Button>
    </div>
  </>
)

export { RemoveGuestWithoutBranches }
